<template>
    <div class="row simple-point">
		<div v-for="(item, index) in config" :key="index" class="col-sm-12 col-md-12 col-lg-4">
			<div class="card card-body border-0 d-flex flex-row align-items-center box-container mb-2">
				<img :src="item.image_url" alt="">
				<div class="overflow-hidden">
					<div class="title">{{ item.title }}</div>
					<div class="description">{{ item.description }}</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
export default {
	name: 'SellingPointWithText',
	props: {
		config: {
			type: Array,
			default: () => [
				{
					title: '24/7 Support',
					description: 'Rest easy, and let us do the heavy lifting for you.',
					image_url: 'https://cdn.ostock.id/icons/selling-points/24-7-Support.png',
				},
				{
					title: 'Free Shipping',
					description: 'Switch to Ostock, and get to play with fast and Free Shipping.',
					image_url: 'https://cdn.ostock.id/icons/selling-points/free-shiping.png',
				},
				{
					title: 'Fast Return',
					description: 'Ostock is fast, free, and simple to use.',
					image_url: 'https://cdn.ostock.id/icons/selling-points/fast-return.png',
				},
			],
		},
	},
	data() {
		return {
		};
	},
};
</script>
<style lang="scss" scoped>
	.box-container {
		// width: 100%;
		height: 208px;
		padding: 40px;
		border-radius: 16px;

		img {
			width: 80px;
			height: 80px;
			margin-right: 40px;
		}

		.title {
			font-weight: 700;
			font-size: 24px;
			margin-bottom: 10px;
			// white-space: nowrap;
		}

		.description {
			font-weight: 400;
			font-size: 16px;
		}

		@media screen and (max-width: 280px) { // galaxy fold
			padding: 18px;
			height: 160px;

			img {
				width: 60px;
				height: 60px;
				margin-right: 18px;
			}

			.title {
				font-size: 18px;
			}

			.description {
				font-size: 14px;
			}
		}
	}
</style>
